import { Fexios } from './fexios.mjs';
export { F as FexiosResponse, F as FexiosResponseContext, c as createFexiosResponse } from './shared/fexios.DFl5Gol9.mjs';
export { a as FexiosError, F as FexiosErrorCodes, b as FexiosResponseError, i as isFexiosError } from './shared/fexios.B-14qd8n.mjs';
export { FexiosHeaderBuilder } from './models/index.mjs';
export { F as FexiosQueryBuilder } from './shared/fexios.TxSvO_qH.mjs';
export { CallableInstance, deepMerge } from './utils/index.mjs';
export { c as clone, i as isPlainObject } from './shared/fexios.DtQgiOCE.mjs';

/**
 * Fexios
 * @desc Fetch based HTTP client with similar API to axios for browser and Node.js
 *
 * @license MIT
 * @author dragon-fish <dragon-fish@qq.com>
 */
const createFexios = Fexios.create;
const fexios = createFexios();

export { Fexios, createFexios, fexios as default, fexios };
//# sourceMappingURL=index.mjs.map
